<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">账号设置</span></div>

		<div class="topselectbox">
			<div class="topselect02">
                <button class="h-btn h-btn-blue" @click="showDrawer">新增</button> 
                <button class="h-btn " @click="loadList">刷新</button> 
            </div>
		</div>

		<div class="tablebox">

			<Table :datas="datas" :height="400" :border="true">
				<TableItem title="账号编码" prop="code" :width="100" />
				<TableItem title="账号名称" align="center" prop="name" :width="100" />
				<TableItem title="账号类型"   align="center" :width="100" >
                    <template #default="{ data }"> 
						<span   >
                            {{  data.actType==1?"现金":
                                data.actType==2?"银行":
                                data.actType==3?"其他":
                                data.actType==4?"微信支付":
                                data.actType==5?"支付宝":
                                data.actType==6?"在线支付":""
                            }}</span> 
					</template>
                </TableItem>
                <TableItem title="开户银行" prop="bankName" align="center" :width="100" />
                <TableItem title="银行账号" prop="actAccount" align="center" :width="100" />
                <TableItem title="最新余额" prop="balance" align="center" :width="100" />
                <TableItem title="关联科目" prop="subjectName" align="center" :width="100" > 
                    <!-- <template #default="{ data }"> 
                        <span style="color:#2d7bf4; cursor: pointer;" @click="del(data.id)"> 设置</span>
					</template> -->
                </TableItem>
				<TableItem title="操作" :width="100" align="center">
					<template #default="{ data }">
						<span style="color:#2d7bf4; cursor: pointer;" @click="showDrawer(data)">编辑</span> &nbsp;&nbsp;
                        <span style="color:#2d7bf4; cursor: pointer;" @click="del(data.id)">删除</span>
					</template>
				</TableItem>
				<template #empty>
					自定义提醒：暂时无数据
				</template>
			</Table>
		</div>
 

		<a-drawer title="编辑设置" width="50%" :closable="false" :visible="visible" @close="onClose">

			<div class="fiveeditbox">
				<ul>
					<li>
						<p>*账号编码：</p><a-input placeholder="账号编码：" :value="showdata.code" v-model="showdata.code" />
					</li>
                    <li>
						<p>*账号名称：</p><a-input placeholder="账号名称：" :value="showdata.name" v-model="showdata.name" />
					</li>
					<li>
						<p>*账号类型：</p>
                        <a-select v-model="showdata.actType" style="width:100%"   >
                            <a-select-option   :value="1">现金</a-select-option>
                            <a-select-option   :value="2">银行</a-select-option>
                            <a-select-option   :value="3">其他</a-select-option>
                            <a-select-option   :value="4">微信支付</a-select-option>
                            <a-select-option   :value="5">支付宝</a-select-option>
                            <a-select-option   :value="6">在线支付</a-select-option>
                        </a-select>
					</li>
					<li>
						<p>开户银行</p><a-input placeholder="开户银行" :value="showdata.bankName" v-model="showdata.bankName"  />
					</li>
                    <li>
						<p>银行账号</p><a-input placeholder="银行账号" :value="showdata.actAccount" v-model="showdata.actAccount"  />
					</li>
                     <li>
						<p>最新余额</p><a-input placeholder="最新余额" :value="showdata.balance == undefined?0:showdata.balance" v-model="showdata.balance"  disabled />
					</li>
                     <li>
						<p>关联科目</p>
                        <a-select v-model="showdata.subjectId" style="width:100%" :options="subjectData" show-search :filter-option="filterOption">
                            
                        </a-select>
					</li>
				</ul>
			</div>

			<div :style="{
				position: 'absolute',
				bottom: 0,
				width: '100%',
				borderTop: '1px solid #e8e8e8',
				padding: '10px 16px',
				textAlign: 'right',
				left: 0,
				background: '#fff',
				borderRadius: '0 0 4px 4px',
			}">
				<a-button style="marginRight: 8px" @click="onClose">
					取消
				</a-button>
				<a-button type="primary" @click="onSave">
					确定
				</a-button>
			</div>
		</a-drawer>




	</div>
</template>

<script>

import Qs from "qs";
import moment from 'moment'
import { mapState } from 'vuex'

export default {
	name: "Salarymanage",
	data() {
		return {
			dataList: {},
			datas: [
			],
			visible: false,
			hildrenDrawer: false,
            subjectData:[],
            voucherSelect: [],
            kmFiler: "",
			showdata: {
				name: '',
				id: '',
				companypay: '',
				individualpay: ''
			}
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	created() { 
		this.loadList();
        this.subjectLoad();
	},
	mounted() {

	},
	methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        subjectLoad() {
            this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
                this.voucherSelect = data;	
                if(this.voucherSelect!=undefined && this.voucherSelect.length>0){
                    for(var i = 0;i<this.voucherSelect.length;i++){
                        var ops = {
                            value:this.voucherSelect[i].id,
                            label:this.voucherSelect[i].subjectFullName
                        }
                        this.subjectData.push(ops);
                    }
                    console.log(this.subjectData)
                    // var ops = {
                    //     value=
                    // }
                }
                console.log(this.voucherSelect)
            });
        },
		loadList() {

			var accountSetsId = this.User.accountSetsId;
			 
			var dataarr = [];
 
			this.$api.cashier.act_list(accountSetsId).then(({ data }) => { 
				data.forEach(element => { 
					var datalist = {} 
					datalist.id = element.id;
					datalist.code = element.code;
                    datalist.actType = element.actType;
					datalist.name = element.name;
					datalist.bankName = element.bankName;
					datalist.actAccount = element.actAccount;
					datalist.balance = element.balance;
					datalist.subjectId = element.subjectId ;
					datalist.status = element.status ;
					datalist.subjectName = element.subjectName ;
					dataarr.push(datalist); 
					this.datas = dataarr;
				});

			})
		},

		showDrawer(data) {
			this.visible = true; 
            if(data==undefined || data.id==undefined){
                this.showdata={};
            }else{
			    this.showdata = data; 
            }
		},
		onClose() {
			this.visible = false;
		},
		onSave() {
			var showdata = this.showdata;
			showdata.accountSetsId = this.User.accountSetsId;
			var that = this;
 
			if(showdata.id!=undefined){
				this.$api.cashier.act_edit(showdata).then(data => {
					if (data.code == 200) {
						that.loadList();
						this.$message.success('编辑成功');
						this.visible = false;
					} else {
						this.$message.error('编辑失败');
					}
				})
			}else{
				this.$api.cashier.act_add(showdata).then(data => {
					if (data.code == 200) {
						that.loadList();
						this.$message.success('添加成功');
						this.visible = false;
					} else {
						this.$message.error('添加失败');
					}


				})
			}
 

		},
        del(id) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.cashier.act_del(id).then(() => {
						this.loadList();
					})
				})
			},
		showChildrenDrawer() {
			this.childrenDrawer = true;
		},
		onChildrenDrawerClose() {
			this.childrenDrawer = false;
		},

	},
	mounted() {

	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.topselectbox {}

.topselectbox .topselect02 {
	padding-top: 15px;
	padding-left: 20px;
}

.tablebox {
	padding-left: 20px;
	padding-top: 20px;
}

.fiveeditbox {
	width: 500px;
	margin: 0 auto;
}

.fiveeditbox ul li {}

.fiveeditbox ul li p {
	font-size: 15px;
	padding-bottom: 5px;
	padding-top: 10px;
}
</style>
